"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.terminalProfile = void 0;
exports.terminalProfile = {
    name: 'terminal',
    methods: ['log'],
};
//# sourceMappingURL=profile.js.map